
import { Vue, Component, Prop } from 'vue-property-decorator'
import Building from '@/types/building'
import { can } from '@/globalFunctions'

@Component({
  methods: { can },
  components: {}
})

export default class BuildingFinancialTab extends Vue {
  @Prop({ default: false, type: Boolean }) editable!: boolean

  settings = {
    routeNames: { list: 'buildings', show: 'buildingShow', edit: 'buildingEdit' },
    routeParamKey: 'buildingId',
    functionNames: { setCurrent: 'setCurrentBuilding', save: 'saveBuilding' },
    getterNames: { current: 'currentBuilding', loading: 'loadingBuilding' }
  }

  get currentItem () : Building {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get canEdit () : boolean {
    return this.editable && can('buildings.financial.edit')
  }
}
